import {combineReducers} from 'redux'
import entities from './entities'
import orderbook from './orderbook'
import aggTrades from './aggTrades'
import common from './common'
import userData from './userData'
import orders from './orders'
import orderForm from './orderForm'
import openAccountInfo from './openAccountInfo'
import feeInfo from './feeInfo'
import scale from './scale'
import fundingHistory from './fundingHistory'

export const initialState = {scale: 500}

export const reducer = combineReducers({
  entities,
  orderbook,
  aggTrades,
  common,
  userData,
  orderForm,
  orders,
  openAccountInfo,
  feeInfo,
  scale,
  fundingHistory
})
